<template>
  <content-dialog
    v-model="dialogOpen"
    fullscreen-mobile
    no-backdrop-dismiss
    title="Edit Licence"
    width="600px"
    :card-visible="!!licenceObject"
    :tags="[helpCodes.createLicence, helpCodes.licences]"
  >
    <q-list
      v-if="!!licenceObject"
      dense
    >
      <detail-item
        with-input
        icon="mdi-account"
        name="Staff Member"
        required
      >
        <user-input-popover
          v-model="licenceObject.user"
          dense
          outlined
          icon="mdi-magnify"
          placeholder="Find Staff Member..."
          :error="!!errors['user_id']"
          :error-message="errors['user_id'] ? errors['user_id'][0] : null"
        />
      </detail-item>
      <detail-item
        with-input
        icon="mdi-earth"
        name="Location"
        required
      >
        <country-picker
          :state="licenceObject.state_id"
          :error="!!errors['state_id']"
          :error-message="errors['state_id'] ? errors['state_id'][0] : null"
          mode="state"
          @set-state="(val) => licenceObject.state_id = val"
        />
      </detail-item>
      <detail-item
        icon="mdi-card-account-details"
        name="Licence Number"
        with-input
        required
      >
        <q-input
          v-model="licenceObject.licence_number"
          bottom-slots
          hide-bottom-space
          outlined
          dense
          counter
          :maxlength="50"
          :error="!!errors['licence_number']"
          :error-message="errors['licence_number'] ? errors['licence_number'][0] : null"
        />
      </detail-item>
      <detail-item
        icon="mdi-text-short"
        name="Title / Descriptor"
        with-input
      >
        <q-input
          v-model="licenceObject.descriptor"
          bottom-slots
          hide-bottom-space
          :error="!!errors['descriptor']"
          :error-message="errors['descriptor'] ? errors['descriptor'][0] : null"
          outlined
          dense
          hint="Short title outlining the type of licence. Visible on client documents."
        />
      </detail-item>
      <detail-item
        icon="mdi-calendar"
        name="Expiry Date"
        with-input
      >
        <date-picker
          v-model="licenceObject.expiry_date"
          :error="!!errors['expiry_date']"
          :error-message="errors['expiry_date'] ? errors['expiry_date'][0] : null"
          clearable
          dense
          outlined
          hint="We'll send you a notification if the licence is due to expire"
        />
      </detail-item>
    </q-list>

    <template #bottom>
      <q-toolbar v-if="!!licenceObject">
        <q-space />
        <q-btn
          label="Save"
          icon-right="done"
          color="green"
          @click="saveChanges"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
export default {
  props: {
    licence: {
      type: Object,
      default: null
    }
  },
  emits: ['saved'],
  data () {
    return {
      licenceObject: null,
      errors: {},
      dialogOpen: false
    }
  },
  methods: {
    open () {
      this.licenceObject = JSON.parse(JSON.stringify(this.licence))
      this.errors = {}
      this.dialogOpen = true
    },
    async saveChanges () {
      this.errors = {}

      this.$loading.show({ message: 'Saving licence...' })
      const { status, errors, payload } = await this.$put('v1/business/company/licences', {
        licence_id: this.licenceObject.id,
        user_id: this.licenceObject.user ? this.licenceObject.user.id : null,
        licence_number: this.licenceObject.licence_number,
        expiry_date: this.licenceObject.expiry_date,
        state_id: this.licenceObject.state_id,
        descriptor: this.licenceObject.descriptor
      })
      this.$loading.hide()

      if (status === 'success') {
        this.$q.notify({
          message: 'Licence successfully saved',
          color: 'green'
        })
        this.dialogOpen = false
        this.licenceObject = null
        this.$bus.emit('licences:reload', true)
        this.$emit('saved', payload.licence)
      }
      else {
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    }
  }
}
</script>
